<div class="mb-xlg" @fadeInAnimation
  [ngClass]="{
    'card-container-shadow': showCard
  }"
>
  <div class="title-section mb-xlg">
    <p class="text-info-bold mb-xs text-upper-case">Clasificaciones</p>
    <p class="text-info mt-xs">Mediante la aplicación de fórmulas de inferencia se determina la clasificación del paciente.</p>
  </div>

  <ng-container *ngFor="let category of complexCategories; index as i">
    <div class="mb-md">
      <nz-tag [nzColor]="colorsCategory[i]" class="text-upper-case">{{ es_MX[category.name] }} </nz-tag>
    </div>
    <div class=""> <!-- container-measurements-autogenerate -->
      <ng-container *ngFor="let measurement of category.data; index as i">
        <ng-container *ngTemplateOutlet="category.name === 'CARDIOVASCULAR_RISK' ? tplCardiovascularRisk : category.name === 'child' ? tplChild :
          tplEmpty, context: {measurement: measurement}"></ng-container>

      </ng-container>
    </div>
    <nz-divider *ngIf="i <complexCategories.length - 1"></nz-divider>
  </ng-container>

  <div *ngIf="this.imcValue">
    <div class="mb-md">
      <nz-tag [nzColor]="colorsCategory[9]" class="text-upper-case">IMC </nz-tag>
    </div>
    <div class="new-measurement-autogenerate complex mb-sm">
      <p class="text-info-bold mb-xs text-upper-case">INDICE DE MASA CORPORAL</p>
      <app-imc-table
        [imcValue]="this.imcValue"
      ></app-imc-table>
    </div>
  </div>


  <div *ngIf="complexCategories.length === 0 && !this.imcValue" class="mt-xlg">
    <nz-empty [nzNotFoundContent]="'No hay fórmulas aplicables al paciente, es posible que se requiera registrar algunas mediciones antes'"
      style="margin: auto;"></nz-empty>
  </div>
</div>


<!-- tewmplates para fórmulas complejas -->


<ng-template #tplCardiovascularRisk let-measurement="measurement">

  <div class="new-measurement-autogenerate complex mb-sm" [class.active]="measurement['checked']">
    <p class="text-info-bold mb-xs text-upper-case"> {{ es_MX[measurement.name] }} / {{ measurement.metadata?.gender | getTranslateEnum:'gender' }}</p>

    <div>
      <div class="tw-mb-5">
        <span class="option-item active">
          Clasificación
        </span>
        <div class="tw-mt-1">
          <app-body-type [metadata]="measurement.metadata"></app-body-type>
        </div>

        <div class="grade-container tw-mt-5">
          <div class="thermometer">
            <div class="thermometer-indicator"
                 [ngClass]="{
                'thermometer-indicator-very-slight': measurement.metadata?.risk === cardiovascularRiskEnum.VERY_SLIGHT,
                'thermometer-indicator-mild': measurement.metadata?.risk === cardiovascularRiskEnum.MILD,
                'thermometer-indicator-moderate': measurement.metadata?.risk === cardiovascularRiskEnum.MODERATE,
                'thermometer-indicator-high': measurement.metadata?.risk === cardiovascularRiskEnum.HIGH,
                'thermometer-indicator-very-high': measurement.metadata?.risk === cardiovascularRiskEnum.VERY_HIGH
              }"
            >
            </div>
          </div>
        </div>

        <p class="text-info mt-xs">
          Grado {{ measurement.metadata?.grade }}, Riesgo <span [ngStyle]="{'color': classificationCardiovascularRisk[measurement.metadata?.risk] }">
            {{ measurement.metadata?.risk | getTranslateEnum:'cardiovascularRisk' }}
          </span>
        </p>
      </div>
      <app-icc-imc-relation-table
        [metadata]="measurement.metadata"
      ></app-icc-imc-relation-table>
    </div>
  </div>
</ng-template>


<ng-template #tplChild let-measurement="measurement">
  <div class="new-measurement-autogenerate complex mb-sm" [class.active]="measurement['checked']">
    <p class="text-info-bold mb-xs text-upper-case"> {{ es_MX[measurement.name] }} </p>
    <p class="text-info mb-xxs">Percentiles recomendados: {{ measurement.metadata?.idealPercentileLow }} a {{
      measurement.metadata?.idealPercentileHigh }}</p>
    <ul class="ml-xlg">
      <li class="text-info">Valor de percentil bajo: {{ measurement.metadata?.idealLow }}</li>
      <li class="text-info">Valor de percentil alto: {{ measurement.metadata?.idealHigh }}</li>
    </ul>
    <nz-divider></nz-divider>
    <p class="text-info mb-xxs">Percentiles reales: {{ measurement.metadata?.realPercentileLow }} a {{
      measurement.metadata?.realPercentileHigh }}</p>
    <ul class="ml-xlg">
      <li class="text-info">Valor de percentil bajo: {{ measurement.metadata?.realLow }}</li>
      <li class="text-info">Valor de percentil alto: {{ measurement.metadata?.realHigh }}</li>
    </ul>
    <nz-divider></nz-divider>
    <p class="text-info mb-xs">Clasificación</p>
    <p *ngIf="classificationIMC[indexClassificationSelected]" class="text-info mt-xs">Desviación estándar: {{ (measurement.metadata?.realLow -
      measurement.metadata.idealLow).toFixed(2)}}</p>
    <p *ngIf="classificationIMC[indexClassificationSelected]" class="text-info mt-xxs">
      El paciente se encuentra {{classificationIMC[indexClassificationSelected].prefix}} <span class="text-bold" [ngStyle]="{'color':
        classificationIMC[indexClassificationSelected].color}">{{ classificationIMC[indexClassificationSelected].value }}</span></p>
  </div>
</ng-template>

<ng-template #tplEmpty>

</ng-template>
